<div class="backDrop center white" *ngIf="visible$ | async">
    <ng-container *ngIf="{height: height$ | async, width: width$ | async} as context">
        <div class="modal-dialog modal-lg" [style.height]="context.height" [style.width]="context.width" [style.maxWidth]="'90vw'" [style.maxHeight]="'90vh'">
            <div class="modal-content" [style.height]="context.height" [style.width]="context.width" [style.maxWidth]="'90vw'" [style.maxHeight]="'90vh'">
                <div class="dialog-body">
                    <div class="icon-div">
                        <i class="far fa-exclamation-triangle fa-5x"></i>
                    </div>
                    <div class="warning-div" [innerHtml]="messageHtml"></div>
                    <div class="checkbox-div">
                        <dx-check-box [disabled]="!ls"
                            text="Don't show this again"
                            [value]="!(keepshowing$ | async)"
                            (onValueChanged)="onKeepShowingChanged($event)">
                        </dx-check-box>
                    </div>
                </div>
                <div class="dialog-footer">
                    <button class="btn btn-warning" (click)="ok()" style="margin-bottom:5px">OK</button>
                </div>
            </div>
        </div>
    </ng-container>
</div>
